import { string } from 'yup';

// interface IValidation {
//   [name: string]: object
// }
export const validation: any = {
  email: string().email('error.validation.email').required('error.validation.emailRequired'),
  firstName: string().required('error.validation.lastname'),
  lastName: string().required('error.validation.firstname'),
};

export const validateEmail = (email: string) => {
  const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(email);
};

export const validatePhoneNum = (phoneNum: string) => {
  const phoneNumRegex = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/;
  return phoneNumRegex.test(phoneNum);
};

export const validateRequired = (value?: string | boolean) => value !== undefined && value !== null && value !== '';
